export const AmslerGrid = ({ imageUrl }: { imageUrl: string }) => {
  return (
    <svg
      style={{ width: '100%', height: 'auto' }}
      xmlns="http://www.w3.org/2000/svg"
      width="234.662"
      height="235.442"
      viewBox="0 0 234.662 235.442"
    >
      <g id="Grille_de_test" data-name="Grille de test" transform="translate(0.5 0.5)">
        <g id="Group_189" data-name="Group 189">
          <path
            id="path60"
            d="M-5155.833,1324.495H-5389.5"
            transform="translate(5389.495 -1090.053)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="rect24"
            d="M-5389.5,1145.337h233.662"
            transform="translate(5389.495 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1689"
            d="M-5389.5,1154.3h233.662"
            transform="translate(5389.495 -1142.897)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1691"
            d="M-5389.5,1163.257l233.662,0"
            transform="translate(5389.495 -1140.457)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1693"
            d="M-5389.5,1172.216l233.662,0"
            transform="translate(5389.495 -1138.017)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1695"
            d="M-5389.5,1181.172l233.662,0"
            transform="translate(5389.495 -1134.752)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1697"
            d="M-5389.5,1190.128l233.662,0"
            transform="translate(5389.495 -1131.91)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1699"
            d="M-5389.5,1199.083l233.662,0"
            transform="translate(5389.495 -1129.068)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1701"
            d="M-5389.5,1208.041l233.662,0"
            transform="translate(5389.495 -1126.225)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1703"
            d="M-5389.5,1217l233.662,0"
            transform="translate(5389.495 -1124.169)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1705"
            d="M-5389.5,1225.958l233.662,0"
            transform="translate(5389.495 -1120.538)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1707"
            d="M-5389.5,1234.917l233.662,0"
            transform="translate(5389.495 -1117.695)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1709"
            d="M-5389.5,1243.876l233.662,0"
            transform="translate(5389.495 -1114.852)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1711"
            d="M-5389.5,1252.832l233.662,0"
            transform="translate(5389.495 -1112.01)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1713"
            d="M-5389.5,1261.788h233.662"
            transform="translate(5389.495 -1109.167)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1715"
            d="M-5389.5,1270.75l233.662,0"
            transform="translate(5389.495 -1106.323)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1717"
            d="M-5389.5,1279.708l233.662,0"
            transform="translate(5389.495 -1103.481)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1719"
            d="M-5389.5,1288.662l233.662,0"
            transform="translate(5389.495 -1100.639)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1721"
            d="M-5389.5,1297.623l233.662,0"
            transform="translate(5389.495 -1097.373)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1723"
            d="M-5389.5,1306.579l233.662,0"
            transform="translate(5389.495 -1094.933)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1725"
            d="M-5389.5,1315.535l233.662,0"
            transform="translate(5389.495 -1092.494)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
        </g>
        <g id="Group_188" data-name="Group 188" transform="translate(0 0)">
          <path
            id="path62"
            d="M-5389.5,1379.779V1145.337"
            transform="translate(5389.495 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path58"
            d="M-5210.336,1145.337v234.442"
            transform="translate(5443.998 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1807"
            d="M-5380.531,1379.778l0-234.441"
            transform="translate(5392.717 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1809"
            d="M-5371.577,1379.778l0-234.441"
            transform="translate(5395.156 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1811"
            d="M-5362.62,1379.778l0-234.441"
            transform="translate(5397.596 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1813"
            d="M-5353.66,1379.778V1145.337"
            transform="translate(5400.553 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1815"
            d="M-5344.7,1379.778V1145.337"
            transform="translate(5403.316 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1817"
            d="M-5335.746,1379.778l0-234.441"
            transform="translate(5406.08 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1819"
            d="M-5326.786,1379.778l0-234.441"
            transform="translate(5408.846 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1821"
            d="M-5317.828,1379.778V1145.337"
            transform="translate(5411.61 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1823"
            d="M-5308.872,1379.778l0-234.441"
            transform="translate(5414.374 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1825"
            d="M-5299.913,1379.778l0-234.441"
            transform="translate(5417.138 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1827"
            d="M-5290.954,1379.778l0-234.441"
            transform="translate(5419.903 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1829"
            d="M-5282,1379.778l0-234.441"
            transform="translate(5422.667 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1831"
            d="M-5273.037,1379.778l0-234.441"
            transform="translate(5425.431 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1833"
            d="M-5264.079,1379.778l0-234.441"
            transform="translate(5428.195 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1835"
            d="M-5255.124,1379.778l0-234.441"
            transform="translate(5430.958 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1837"
            d="M-5246.166,1379.778l0-234.441"
            transform="translate(5433.722 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1839"
            d="M-5237.212,1379.778l0-234.441"
            transform="translate(5436.678 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1841"
            d="M-5228.253,1379.778V1145.337"
            transform="translate(5439.118 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
          <path
            id="path1843"
            d="M-5219.3,1379.778V1145.337"
            transform="translate(5441.557 -1145.337)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="11.339"
            strokeWidth="1"
          />
        </g>
        <circle
          id="path1845"
          cx="11.722"
          cy="11.722"
          r="11.722"
          transform="translate(105.968 105.092)"
          stroke="#000"
          strokeMiterlimit="11.339"
          strokeWidth="1.386"
          opacity="0.8"
        />
      </g>
      <image xlinkHref={imageUrl} width="234.662" height="235.442" />
    </svg>
  )
}
